import React, { PureComponent } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Document, Page } from 'react-pdf'
import { getFileExtension } from '../../utils/filters'
import SoftwareDevelopersIcon from './icons/software-developers-icon.svg'
import './styles.css'
import ReactMarkdown from 'react-markdown'

const getIcon = (tags) => {
  if (tags.includes('IOS')) {
    return <i className='fa fa-apple fa-2x' aria-hidden='true' />
  } else if (tags.includes('Android')) {
    return <i className='fa fa-android fa-2x' aria-hidden='true' />
  } else {
    return <i className={`fa fa-file-pdf-o fa-2x`} aria-hidden='true' />
  }
}

class SoftwareDevelopers extends PureComponent {
  state = {
    readme: null,
    file: '',
    numPages: null,
    pageNumber: 1,
  }
  onDocumentLoad = ({ numPages }) => this.setState({ numPages })

  openMarkdown = async (file) => {
    const response = await window.fetch(file)
    const readme = await response.text()
    this.setState({ readme })
  }

  openPdf = (file) => this.setState({ file })

  open = (file) => window.open(file, '_blank')

  render() {
    const { props, state } = this

    return (
      <div className={'documentation-block'}>
        <div>
          {state.readme && (
            <Modal size={'lg'} show onHide={() => this.setState({ readme: '' })}>
              <Modal.Body>
                <ReactMarkdown source={state.readme} />
              </Modal.Body>
              <Modal.Footer />
            </Modal>
          )}
          {state.file && (
            <Modal size={'lg'} show onHide={() => this.setState({ file: '' })}>
              <Modal.Header closeButton>
                <Modal.Title>Document</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Document file={state.file} onLoadSuccess={this.onDocumentLoad}>
                  {Array.from(new Array(state.numPages), (el, index) => (
                    <Page width={800} key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                </Document>
                <div>
                  {state.numPages && (
                    <p>
                      Page {state.pageNumber} of {state.numPages}
                    </p>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='default' onClick={() => this.setState({ file: '' })}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
        <div className={'documentation-block-title'}>
          <div className={'documentation-block-title__icon'}>
            <img src={SoftwareDevelopersIcon} alt='' />
          </div>
          <h2>Software Developers</h2>
        </div>
        <div className={'documentation-block-list'}>
          {props.documents.map((document, index) => (
            <div key={index} className={'documentation-block-list-item'}>
              {getIcon(document.tags)}
              <a href={document.file} target={'_blank'} rel='noreferrer'>
                {' '}
                {document.title}
              </a>
              <span className={'documentation-block-list-actions'}>
                <i className='fa fa-download' aria-hidden='true' onClick={() => this.open(document.file)} />
                {getFileExtension(document.file) === 'pdf' && (
                  <i className='fa fa-eye' aria-hidden='true' onClick={() => this.openPdf(document.file)} />
                )}
                {getFileExtension(document.file) === 'md' && (
                  <i className='fa fa-eye' aria-hidden='true' onClick={() => this.openMarkdown(document.file)} />
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default SoftwareDevelopers
